export default "__VITE_ASSET__BqdDgXMx__$_?nuxt_component=async&nuxt_component_name=Svgo登录b2b&nuxt_component_export=default__"